export default __webpack_public_path__ + "static/media/UCMobileBackgroundFinal.0da88185.jpg";